import styled from 'styled-components'

export const Box = styled.div`
  overflow-y: auto;
  padding: 0 var(--spacer-6);
  min-height: 90vh;
  margin-bottom: 4.875rem;

  > * {
    color: var(--gray-900);
    padding: 0;
    margin: 0;
  }
`

export const Title = styled.h2`
  font-weight: var(--font-weight-light);
  font-size: var(--text-5);
  line-height: 120%;
  margin-bottom: var(--spacer-7);
`

export const Subheading = styled.h3`
  font-size: 1.125rem;
  line-height: 120%;
  font-weight: 800;
  margin-bottom: var(--spacer-1);
`

export const SubheadingDesc = styled.p`
  font-size: 0.875rem;
  color: var(--gray-500);
`
